import { QuestionOutlined } from '@ant-design/icons';
import { Modal, Typography } from 'antd';
import React from 'react';
import styles from 'styles/components/supportChat.module.scss';

const SupportChat = () => {
  return (
    <div
      onClick={() => {
        Modal.info({
          title: 'Contact support',
          content: (
            <div>
              <div>Have a question? </div>
              <div>
              Contact us at{' '}
                <Typography.Text copyable strong>
                  support@karmalinks.io
                </Typography.Text>
              </div>
            </div>
          ),
        });
      }}
      className={styles.supportChat}
    >
      <QuestionOutlined className={styles.icon} />
    </div>
  );
};

export default SupportChat;
